module.exports = __webpack_public_path__ + "img/banner_coun_guide_03.e8d1cc87.png";